import React from 'react'
import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridItemChangeEvent,
    GridPageChangeEvent,
    GridPagerSettings,
    GridRowProps,
    GridNoRecords
} from "@progress/kendo-react-grid";
import { Icon } from "@iconify/react";



function holidayList(Props: any) {

  const dateCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.date && new Date(parseInt(props.dataItem.date)).toDateString().slice(3)}
    </td>
  )
}

  return (
    <div className='tableStyle no-top-padd no-min-height tableMaxHeight'>
    <Grid
       data={Props.data}
   >
    <GridNoRecords>
                    <div className="noData">
                        <Icon icon="mdi:smiley-neutral-outline" />
                        No data to display
                    </div>
                </GridNoRecords>
       <Column field="date"  title="Date"  cell={dateCell}/>
       <Column field="description" title="Holiday"  />
   </Grid>
</div>
  )
}

export default holidayList